import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Router } from '@angular/router'
import { catchError, Observable, throwError } from 'rxjs'
import { AuthService } from 'app/core/auth/auth.service'
import { AppModeService } from '@store/services/app-mode.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /** Évite plusieurs redirections si plusieurs requêtes échouent en 401 en parallèle. */
  private handling401 = false

  constructor(
    private _authService: AuthService,
    private appModeService: AppModeService,
    private router: Router,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req.clone()

    if (this.appModeService.isTestSurvey$.value) {
      return next.handle(newReq)
    }

    if (this._authService.accessToken) {
      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
      })
    }

    return next.handle(newReq).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          console.error('[AuthInterceptor] 401 Unauthorized', {
            url: req.url,
            method: req.method,
            status: error.status,
            statusText: error.statusText,
            body: error.error,
          })

          this.handleUnauthorized()
        }
        return throwError(() => error)
      })
    )
  }

  private handleUnauthorized(): void {
    if (this.handling401) {
      return
    }
    this.handling401 = true

    const redirectUrl = this.router.url
    const isPublicPublication = redirectUrl.includes('/publication/public')

    localStorage.removeItem('accessToken')
    this._authService.softSignOut()

    if (isPublicPublication || redirectUrl.includes('/sign-in')) {
      this.handling401 = false
      return
    }

    void this.router.navigate(['/sign-in'], { queryParams: { redirectURL: redirectUrl } }).finally(() => {
      this.handling401 = false
    })
  }
}
